/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:14:01+02:00
*/

// based on: https://github.com/callemall/material-ui/blob/master/src/internal/Overlay.js

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import transitions from './../../../transitions/transitions';
import AutoLockScrolling from './../../../internals/AutoLockScrolling';


function getStyles({
  transitionEnabled,
  show,
}) {
  const style = {
    position: 'fixed',
    height: '100%',
    width: '100%',
    top: 0,
    left: '-100%',
    opacity: 0,

    // Two ways to promote overlay to its own render layer
    willChange: 'opacity',
    transform: 'translateZ(0)',

    transition:
        transitionEnabled && `${transitions.easeOut('0ms', 'left', '400ms')}, ${
          transitions.easeOut('400ms', 'opacity')}`,
  };

  if (show) {
    Object.assign(style, {
      left: 0,
      opacity: 1,
      transition: `${transitions.easeOut('0ms', 'left')}, ${
        transitions.easeOut('400ms', 'opacity')}`,
    });
  }

  return style;
}


class Overlay extends Component {
  render() {
    const {
      autoLockScrolling,
      show,
      style,
      transitionEnabled, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;
    const styles = getStyles(this.props);

    return (
      <div
        className="overlay"
        {...other}
        ref={(component) => this.overlayRef(component)}
        style={Object.assign(styles, style)}
      >
        {autoLockScrolling && <AutoLockScrolling lock={show} />}
      </div>
    );
  }

  overlayRef(component) {
    this.overlay = component;
  }

  /**
     * public api to set the opacity of the overlay
     */
  setOpacity(opacity) {
    this.overlay.style.opacity = opacity;
  }
}
Overlay.propTypes = {
  autoLockScrolling: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  /**
    * Override the inline-styles of the root element.
    */
  style: PropTypes.object,
  transitionEnabled: PropTypes.bool,
};
Overlay.defaultProps = {
  autoLockScrolling: true,
  style: {},
  transitionEnabled: true,
};
export default Overlay;

